import states from "strings/states.json";

export interface State {
  label: string;
  value: string;
}

export function getStateByCode(stateCode: string): State {
  for (const state of states) {
    if (stateCode === state.value) {
      return state;
    }
  }

  throw new Error("stateCode is invalid");
}
